
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
  Divider,
  Box
} from '@mui/material';
import { FollicularStudy } from '../../../components/CycleOverViewList/CycleOverviewReport/CycleOverviewReportHelper';
import { useTranslation } from 'react-i18next';

interface FollicularScanDateWiseReportProps {
  follicular_studies: FollicularStudy[];
}

const FollicularScanDateWiseReport: React.FC<FollicularScanDateWiseReportProps> = ({ follicular_studies}) => {
  const { t: tGeneral } = useTranslation('general');
  return (
    <Box sx={{ pt: 4 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>{tGeneral('Follicular Study Details')}</Typography>
        
      {follicular_studies.map((study) => (
        <div key={study.id} style={{ marginBottom: '40px' }}>
          
          {/* HEADER */}
          <Grid container spacing={3} sx={{ mb: 2 }}>
            <Grid item xs={3}>
              <Typography variant="body2">Date</Typography>
              <Typography>{study.date}</Typography>
            </Grid>

            <Grid item xs={3}>
              <Typography variant="body2">Time</Typography>
              <Typography>{study.time}</Typography>
            </Grid>


            <Grid item xs={3}>
              <Typography variant="body2">Cycle Day</Typography>
              <Typography>{study.cycle_day ?? '-'}</Typography>
            </Grid>
          </Grid>

          {/* TABLE */}
          <TableContainer component={Paper} elevation={0}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    <strong>Left Ovary</strong>
                  </TableCell>
                  <TableCell colSpan={2} align="center">
                    <strong>Right Ovary</strong>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell><strong>Follicular Size (mm)</strong></TableCell>
                  <TableCell><strong>No. of Follicles</strong></TableCell>
                  <TableCell><strong>Follicular Size (mm)</strong></TableCell>
                  <TableCell><strong>No. of Follicles</strong></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {study.details.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.left_follicle_size}</TableCell>
                    <TableCell>{row.left_no_of_follicles}</TableCell>
                    <TableCell>{row.right_follicle_size}</TableCell>
                    <TableCell>{row.right_no_of_follicles}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* FOOTER */}
          <Grid container spacing={3} sx={{ mt: 3 }}>
            <Grid item xs={6}>
              <Typography variant="body2">Endometrium Thickness (mm)</Typography>
              <Typography>{study.endometrium_thickness}</Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body2">Endometrium Morphology</Typography>
              <Typography>{study.endometrium_morphology_label}</Typography>
            </Grid>
          </Grid>

          <Divider sx={{ mt: 4, bgcolor: 'grey.900' }} />
        </div>
      ))}
    </Box>
  );
};

export default FollicularScanDateWiseReport;
